import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrSettingService {


  constructor(private http: HttpClient) { }
  
  url = environment.serverAPI4 + "/api";


  getHrSettingsData(): Observable<Object> {
    return this.http.get(`${this.url}/hrConfig`);
  }


  saveHrSetting(crmConfig: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/hrConfig`, crmConfig);
  }




}


